var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-card',[_c('div',{staticClass:"text-xs-center pt-3 font-weight-medium"},[_vm._v(_vm._s(_vm.$t('ARTWORK.PAYMENT_OPTIONS_TITLE')))]),_c('div',{staticClass:"payment-methods"})])}
var staticRenderFns = []

export { render, staticRenderFns }